import { useState, useEffect } from "react";
import Style from "./ContractTemplateDetailStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";
import PageTitle from "../../components/PageTitle";
import InfoModal from "../../shared/Bootstrap/InfoModal";
import { InputImage } from "../../components/InputImage/InputImage";
import { AxiosRequestConfig } from "axios";


export default function ContractTemplateDetail(props) {


  const [updateClients, setUpdateClients] = useState("0");
  const [automaticallyGenerate, setAutomaticallyGenerate] = useState("0");
  const [showFurnitureImages, setShowFurnitureImages] = useState("0");
  const [enabled, setEnabled] = useState("0");

  const [template, setTemplate] = useState({} as File);
  const [deleteTemplate, setDeleteTemplate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const templateId = parseInt(props.match?.params?.contractTemplateId) || 0;
  const creatingNew = true;//templateId <= 0;

  useEffect(() => {
    if (!creatingNew) {
      LoadTemplate(templateId);
    } else {
      setLoading(false);
    }
  }, []);

  async function LoadTemplate(templateId) {
    // Carregar Template de contrato pelo id
    try {
      const result = await api.get(`/contractTemplate/${templateId}`);
      if (result.data.success) {
        let contractTemplate = result.data.result;
        setUpdateClients(contractTemplate.updateClients)
        setAutomaticallyGenerate(contractTemplate.automaticallyGenerate)
        setShowFurnitureImages(contractTemplate.showFurnitureImages)
        setEnabled(contractTemplate.enabled)
        setLoading(false);
      }
    } catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Não foi possível carregar o template de contrato");
      setLoading(false);
    }
  }

  async function OnSubmit() {
    try {
      setLoading(true);
      onClosePopUp();

      const options: AxiosRequestConfig = {};
      const formData = new FormData();

      if (template.name && !deleteTemplate) {
        formData.append("template", template, template.name);
      }
      if (!creatingNew) {
        formData.append("deleteTemplate", deleteTemplate.toString());
      }
      formData.append("updateClients", updateClients);
      formData.append("automaticallyGenerate", automaticallyGenerate);
      formData.append("showFurnitureImages", showFurnitureImages);
      formData.append("enabled", enabled.toString());
      await (creatingNew ? api.post(`/contractsTemplates`, formData, options) : api.put(`/contractsTemplates/${templateId}`, formData, options));
      
      if (creatingNew) {
        props.history.goBack();
      } else {
        setShowSuccessPopup(true);
      }
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
      onClosePopUp();
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopUp() {
    setShowPopup(false);
  }

  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Template de contrato editado com sucesso!"
        body="Suas edições foram salvas com sucesso!"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }

  function changeTemplate(event) {
    setTemplate(event.target.files[0]);
    setDeleteTemplate(false);
  };

  return (
    <Style>
      {ShowSuccessPopup()}
      <PageTitle title="Template do Contrato" />
      <div>
        <TwoButtonsModal
          show={showPopup}
          onHide={onClosePopUp}
          loading={loading}
          title={creatingNew ? "Cadastro de template de contrato" : "Edição de template de contrato"}
          body={"Você tem certeza que deseja " + (creatingNew ? "cadastrar este template de contrato?" : "editar este template de contrato?")}
          secondaryText="Fechar"
          secondaryOnClick={onClosePopUp}
          secondaryDisabled={loading}
          primaryText="Confirmar"
          primaryOnClick={OnSubmit}
          primaryDisabled={loading}
        />
        <div>
          <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
              <h2>{creatingNew ? "Cadastro" : "Edição"} de template de contrato</h2>
              <div>
                <label>Atualizar Clientes:</label>
                <input
                  type="checkbox"
                  disabled={loading}
                  value={updateClients}
                  onChange={e => setUpdateClients(e.target.value)}
                />
              </div>
              <div>
                <label>Gerar contrato automático:</label>
                <input
                  type="checkbox"
                  name="automaticallyGenerate"
                  disabled={loading}
                  value={automaticallyGenerate}
                  onChange={e => setAutomaticallyGenerate(e.target.value)}
                />
              </div>
              <div>
                <label>Exibir imagem dos moveis:</label>
                <input
                  type="checkbox"
                  name="showFurnitureImages"
                  disabled={loading}
                  value={showFurnitureImages}
                  onChange={e => setShowFurnitureImages(e.target.value)}
                />
              </div>
              <div>
                <label>Habilitar:</label>
                <input
                  type="checkbox"
                  name="enabled"
                  disabled={loading}
                  value={enabled}
                  onChange={e => setEnabled(e.target.value)}
                />
              </div>
              <div>
                <label>Arquivo do Template:</label>
                <InputImage
                  id="fileTemplate"
                  label=""
                  name="fileTemplate"
                  acceptedMimeTypes=".docx"
                  alt=""
                  OnChange={changeTemplate}
                  OnRemove={() => setDeleteTemplate(true)}
                />
              </div>
              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                onClick={e => {
                  e.preventDefault();
                  onOpenPopUp();
                }}>{creatingNew ? "Cadastrar" : "Editar"}
              </button>
            </form>
          </div>
        </main>
      </div>
    </Style>
  )



}